import { Component, Input, OnInit } from "@angular/core";
@Component({
  selector: "app-view-form-array",
  templateUrl: "./view-form-array.component.html",
  styleUrls: ["./view-form-array.component.scss"],
})
export class ViewFormArrayComponent implements OnInit {
  @Input() public columns;
  public _rows;
  public rowValueNames;
  @Input() set rows(newRows) {
    this._rows = newRows;
    if (newRows && newRows.length) {
      for (let i = 0; i < this._rows.length; i++) {
        this.rowValueNames = Object.keys(this._rows[i]);
      }
    } else {
      this.rowValueNames = [];
    }
  }

  constructor() {}
  ngOnInit() {}
}
